<div *ngIf="show">
  <kendo-grid [kendoGridBinding]="gridData.data" #grid [group]="state.group"
    [pageSize]="state.take" [skip]="state.skip" [sort]="state.sort" [pageable]="true" [navigable]="true"
    (selectionChange)="onSelectionChange($event)" filterable="menu" [filter]="filters" [sortable]="true"
    id="{{cssId}}-grid" [selectable]="{ checkboxOnly: true, mode:
    'multiple' }" [rowSelected]="isRowSelected">
    <kendo-grid-checkbox-column [width]="25" class="kendo-checkbox" *ngIf="canSelect && (type === 'Past Due')">
      <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
        <div class="align-center">
          <input [kendoGridSelectionCheckbox]="idx" class="k-checkbox" type="checkbox" id="{{'chk'+idx}}"
            [disabled]="dataItem.disabled" />
          <label class="k-checkbox-label" for="{{'chk'+idx}}"></label>
        </div>
      </ng-template>
    </kendo-grid-checkbox-column>
    <kendo-grid-checkbox-column [width]="25" class="kendo-checkbox" *ngIf="canSelect && (type === 'Due')">
      <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
        <div class="align-center">
          <input [kendoGridSelectionCheckbox]="idx" class="k-checkbox" type="checkbox" id="{{'dueChk'+idx}}"
            [disabled]="dataItem.disabled" />
          <label class="k-checkbox-label" for="{{'dueChk'+idx}}"></label>
        </div>
      </ng-template>
    </kendo-grid-checkbox-column>
    <kendo-grid-column media="(max-width: 900.98px)" title="Details" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- template for mobile -->
        <dl>
          <dt>
          </dt>
          <dd>
            <div class="align-left">
              <span class="bold">Invoice #: </span>
              <span (click)="viewInvoice(dataItem);dataItem.isClicked=!dataItem.isClicked" class="doc-view">
                <span *ngIf="!dataItem.isClicked" class="k-icon k-i-file-pdf k-i-pdf"></span>
                <a class="clone-link" *ngIf="!dataItem.isClicked">{{dataItem.invoiceNumber}}</a>
                <span *ngIf="dataItem.isClicked" class="k-icon k-i-loading inner"></span>
              </span>
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left">
              <span class="bold">Invoice Date: </span>
              {{ dataItem.invoiceDate | date: 'MM/dd/yyyy' }}
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left" *ngIf="type === 'Past Due' || type === 'Due'">
              <div *ngIf="dataItem.amount > 0">
                <span class="bold">Due Date: </span>
                {{ dataItem.dueDate | date: 'MM/dd/yyyy' }}
              </div>
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left" *ngIf="type === 'Due' && showDifferedDt && showScheduledColumn && dataItem.isSchedulable">
              <div kendoTooltip position="right" tooltipWidth="250" class="bold">
                Scheduled Date<span
                  title="Scheduled date can be selected only for the payments with due date in the future."
                  class="k-icon k-i-information k-i-info"></span>:
              </div>
              <div *ngIf="dataItem.scheduledDate !== undefined && dataItem.amount > 0">
                <kendo-datepicker [min]="minDifDt" [max]="getMaxDt(dataItem.dueDate)" class="textbox dif-date-picker"
                  name="difDate{{dataItem.id}}" id="difDate{{dataItem.id}}" [(ngModel)]="dataItem.scheduledDate"
                  [disabled]="!dataItem.isSchedulable" #issuedDate="ngModel" placeholder="MM/DD/YYYY"
                  (valueChange)="onDateChange(dataItem)" required>
                </kendo-datepicker>
                <div class="top-margin-1" *ngIf="dataItem.showDateError">
                  <span class="tooltip-validation left-margin-0 page-bottom">
                    {{dateError}}
                  </span>
                </div>
              </div>
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left" *ngIf="type === 'Initiated Payments'">
              <span class="bold"> Payment Initiated: </span>
              {{dataItem.paidDate | date: 'MM/dd/yyyy'}}
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left" *ngIf="type === 'Paid'">
              <span class="bold"> Paid: </span>
              {{dataItem.paidDate | date: 'MM/dd/yyyy'}}
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left">
              <span class="bold"> Type: </span>
              {{ dataItem.invoiceType }}
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left" *ngIf="dataItem.groupType !== 'Quarterly Billing'">
              <span class="bold"> Reference: </span>
              {{ dataItem.reference }}
            </div>
            <div *ngIf="dataItem.groupType === 'Quarterly Billing'">
              <span class="bold"> Reference: </span>
              <span>
                <a class="clone-link"
                  (click)="openDialog(dataItem.id)">{{dataItem.reference}}</a>
              </span>
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left" *ngIf="type === 'Past Due'">
              <span class="bold"> Penalty: </span>
              <span> {{dataItem.penalty | currency:'USD'}} </span>
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left" *ngIf="type === 'Past Due'">
              <span class="bold"> Interest: </span>
              <span> {{dataItem.interest | currency:'USD'}} </span>
            </div>
          </dd>
          <dt>
          </dt>
          <dd>
            <div class="align-left">
              <span class="bold"> Amount: </span>
              <span [ngClass]=" 0 > dataItem.amount ? 'neg-amount' : ''">
                {{dataItem.formatAmount}}
              </span>
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="invoiceNumber" media="(min-width: 901px)" title="Invoice #" [width]="75"
      [headerClass]="{'align-id': true}">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-id">
          <span *ngIf="dataItem.invoiceNumber !== ''"
            (click)="viewInvoice(dataItem);dataItem.isClicked=!dataItem.isClicked" class="doc-view">
            <span *ngIf="!dataItem.isClicked" class="k-icon k-i-file-pdf k-i-pdf"></span>
            <a class="clone-link" *ngIf="!dataItem.isClicked">{{dataItem.invoiceNumber}}</a>
            <span *ngIf="dataItem.isClicked" class="k-icon k-i-loading inner"></span>
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="invoiceDate" media="(min-width: 901px)" title="Invoice Date" [width]="50"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <span>
            {{dataItem.invoiceDate | date: 'MM/dd/yyyy'}}
          </span>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <app-date-range-filter [field]="column.field" [filter]="filter" [filterService]="filterService">
        </app-date-range-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="dueDate" media="(min-width: 901px)" title="Due Date" [width]="50"
      [headerClass]="{'align-date': true}" *ngIf="type === 'Past Due' || type === 'Due'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date" *ngIf="dataItem.amount > 0">
          <span>
            {{dataItem.dueDate | date: 'MM/dd/yyyy'}}
          </span>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <app-date-range-filter [field]="column.field" [filter]="filter" [filterService]="filterService">
        </app-date-range-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="scheduledDate" media="(min-width: 901px)" title="'" [width]="100"
      [headerClass]="{'align-date': true}" *ngIf="type === 'Due' && showDifferedDt && showScheduledColumn">
      <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
        <div kendoTooltip position="right" tooltipWidth="250">
          Scheduled Date<span title="Scheduled date can be selected only for the payments with due date in the future."
            class="k-icon k-i-information k-i-info"></span>
        </div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.scheduledDate !== undefined && dataItem.amount > 0">
          <div class="align-date">
            <kendo-datepicker [min]="minDifDt" [max]="getMaxDt(dataItem.dueDate)"
              class="textbox dif-date-picker full-width" name="difDate{{dataItem.id}}" id="difDate{{dataItem.id}}"
              [(ngModel)]="dataItem.scheduledDate" [disabled]="!dataItem.isSchedulable" #issuedDate="ngModel"
              placeholder="MM/DD/YYYY" (valueChange)="onDateChange(dataItem)" required>
            </kendo-datepicker>
          </div>
          <div class="top-margin-1" *ngIf="dataItem.showDateError">
            <span class="tooltip-validation left-margin-0 page-bottom">
              {{dateError}}
            </span>
          </div>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="paidDate" media="(min-width: 901px)" title="Payment Initiated" [width]="50"
      [headerClass]="{'align-date': true}" *ngIf="type === 'Initiated Payments'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <span>
            {{dataItem.paidDate | date: 'MM/dd/yyyy'}}
          </span>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <app-date-range-filter [field]="column.field" [filter]="filter" [filterService]="filterService">
        </app-date-range-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="paidDate" media="(min-width: 901px)" title="Paid" [width]="50"
      [headerClass]="{'align-date': true}" *ngIf="type === 'Paid'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <span>
            {{dataItem.paidDate | date: 'MM/dd/yyyy'}}
          </span>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <app-date-range-filter [field]="column.field" [filter]="filter" [filterService]="filterService">
        </app-date-range-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="invoiceType" media="(min-width: 901px)" title="Type" [width]="75">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-text">
          <span>
            {{dataItem.invoiceType}}
          </span>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="reference" media="(min-width: 901px)" title="Reference" [width]="75">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-text">
          <span *ngIf="dataItem.groupType === 'Quarterly Billing'">
            <a class="clone-link"
              (click)="openDialog(dataItem.id)">{{dataItem.reference}}</a>
          </span>
          <span *ngIf="dataItem.groupType !== 'Quarterly Billing'">{{ dataItem.reference }}</span>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="penalty" title="Penalty" media="(min-width: 901px)" [width]="50"
      *ngIf="type === 'Past Due'" [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">
          <span>
            {{dataItem.penalty | currency:'USD'}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="interest" title="Interest" media="(min-width: 901px)" [width]="50"
      *ngIf="type === 'Past Due'" [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">
          <span>
            {{dataItem.interest | currency:'USD'}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="amount" title="Amount" media="(min-width: 901px)" [width]="75"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">
          <span [ngClass]=" 0 > dataItem.amount ? 'neg-amount' : ''">
            {{dataItem.formatAmount}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="groupType" title="Group" [hidden]="true">
      <ng-template kendoGridGroupHeaderTemplate let-group="group">
        <span>
          {{group.value}}
        </span>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
<!-- POP UP DIALOG FOR REFERENCE USER ENROLLMENT DETAILS -->
<div id="enrollment-dialog" *ngIf="showDialog">
  <kendo-dialog class="app-dialog" (close)="onCancel()" [width]="'75%'">
    <kendo-dialog-titlebar>
      Quarterly Billing Details
    </kendo-dialog-titlebar>
    <div>
      <kendo-grid [kendoGridBinding]="dialogData" [pageable]="true" [pageSize]="10">
        <ng-template kendoGridToolbarTemplate>
          <button type="button" kendoGridExcelCommand class="padding-10">
            <span class="k-icon k-i-file-excel k-i-file-xls k-i-excel k-i-xls" id="enrollment-excel-icon"></span>
            Export to Excel
          </button>
        </ng-template>
        <kendo-grid-column field="ssn" title="SSN" [width]="130" [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-number">
              <span>
                {{dataItem.ssn}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="firstName" title="First Name" [width]="180">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-name">
              <span>
                {{dataItem.firstName}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="mi" title="MI" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-name">
              <span>
                {{dataItem.mi}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="lastName" title="Last Name" [width]="180">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-name">
              <span>
                {{dataItem.lastName}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="locationCode" title="Location" [width]="100" [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-number">
              <span>
                {{dataItem.locationCode}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="system" title="System" [width]="80" [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-number">
              <span>
                {{dataItem.system}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="currentSalary" title="Current Salary" [width]="130"
          [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-number">
              <span>
                {{dataItem.currentSalary | currency: 'USD' : 'symbol' : '1.0-0'}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="birthDate" title="Birth Date" [width]="130" [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-date">
              <span>
                {{dataItem.birthDate | date: 'MM/dd/yyyy'}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="enrollmentDate" title="Enrollment Date" [width]="130"
          [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-date">
              <span>
                {{dataItem.enrollmentDate | date: 'MM/dd/yyyy'}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="jobCode" title="Job Code" [width]="130" [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-number">
              <span>
                {{dataItem.jobCode}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="lastActiveDate" title="Last Active Date" [width]="130"
          [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-date">
              <span>
                {{dataItem.lastActiveDate | date: 'MM/dd/yyyy'}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="percentFullTime" title="Percent Full Time" [width]="130"
          [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-number">
              <span>
                {{dataItem.percentFullTime}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-excel fileName="Enrollment Data.xlsx" [fetchData]="allData"></kendo-grid-excel>
      </kendo-grid>
    </div>
  </kendo-dialog>
</div>
